import type { SidewalkTile } from './PickupSites';
import { totalFare, type FareResult } from './Scoring';

export const EXPECTED_SEC_PER_TILE = 1.3;

export interface FareSummary extends FareResult {
  distanceTiles: number;
  expectedSec: number;
  actualSec: number;
  clean: boolean;
}

export class TaxiMission {
  readonly pickup: SidewalkTile;
  readonly destination: SidewalkTile;
  readonly distanceTiles: number;
  readonly expectedSec: number;

  timeElapsed = 0;
  clean = true;

  constructor(pickup: SidewalkTile, destination: SidewalkTile) {
    this.pickup = pickup;
    this.destination = destination;
    this.distanceTiles = Math.abs(destination.row - pickup.row) + Math.abs(destination.col - pickup.col);
    this.expectedSec = this.distanceTiles * EXPECTED_SEC_PER_TILE;
  }

  tick(delta: number) {
    this.timeElapsed += delta;
  }

  onCrash() {
    this.clean = false;
  }

  complete(): FareSummary {
    const fare = totalFare(this.distanceTiles, this.expectedSec, this.timeElapsed, this.clean);
    return {
      ...fare,
      distanceTiles: this.distanceTiles,
      expectedSec: this.expectedSec,
      actualSec: this.timeElapsed,
      clean: this.clean,
    };
  }
}
